import {
  useGetUrl,
  translations as utilsTranslations,
} from '@seek/ca-myprofile-utils';
import { useTranslations } from '@vocab/react';
import { Text, Stack, Disclosure, TextLink } from 'braid-design-system';
import React, { useEffect, useState } from 'react';

import { useGetProfileVisibilityLevel } from 'src/components/Profile/ProfileVisibility/data';
import { useAppConfig } from 'src/modules/appConfig';
import { VisibilityLevel } from 'src/types/graphql';

import { useResumePrivacyDisclaimers } from '../../../data';

import translations from './.vocab';
import { HiddenLimitedProfileVisibilityMessage } from './HiddenLimitedProfileVisibilityMessage/HiddenLimitedProfileVisibilityMessage';
import { StandardProfileVisibilityMessage } from './StandardProfileVisibilityMessage/StandardProfileVisibilityMessage';

export const PrivacyInfo = () => {
  const { profileVisibilityLevel } = useGetProfileVisibilityLevel();
  const { resumePrivacyDisclaimers } = useResumePrivacyDisclaimers();

  const { t } = useTranslations(translations);
  const { zone, language, isUnifiedSite } = useAppConfig();
  const [linkCopy, setLinkCopy] = useState('');

  useEffect(() => {
    utilsTranslations.getResumePrivacyDisclaimer(language).then((keys) => {
      setLinkCopy(keys['Privacy Statement'].format());
    });
  }, [language]);

  const getUrl = useGetUrl(zone, language, isUnifiedSite);

  const isStandardProfileVisibility =
    profileVisibilityLevel === VisibilityLevel.Standard;

  return (
    <Stack space="medium">
      <Text>
        {resumePrivacyDisclaimers &&
          resumePrivacyDisclaimers.shortParagraphs[0].value}
      </Text>
      {isStandardProfileVisibility ? (
        <StandardProfileVisibilityMessage />
      ) : (
        <HiddenLimitedProfileVisibilityMessage />
      )}
      <Disclosure
        expandLabel={t('Read more')}
        collapseLabel={t('Read less')}
        id="readmore"
        weight="weak"
      >
        <Stack space="medium">
          {resumePrivacyDisclaimers &&
            resumePrivacyDisclaimers.longParagraphs.map((copy, index) => {
              if (copy.isEmphasized) {
                return (
                  <Text weight="strong" key={`${copy.value}-${index}`}>
                    {copy.value}
                  </Text>
                );
              }
              if (copy.value.indexOf(linkCopy) !== -1) {
                const copyArr = copy.value.split(linkCopy);
                return (
                  <Text key={`${copy.value}-${index}`}>
                    {copyArr[0]}
                    {
                      <TextLink
                        weight="weak"
                        hitArea="large"
                        href={getUrl('profile-privacy')}
                      >
                        Privacy Statement
                      </TextLink>
                    }
                    {copyArr[1]}
                  </Text>
                );
              }
              return <Text key={`${copy.value}-${index}`}>{copy.value}</Text>;
            })}
        </Stack>
      </Disclosure>
    </Stack>
  );
};
